import {
  axiosInstance as Repository,
  RESULT_CD,
  RepositoryError,
} from "../repository";

const RESOURCE = "/sign-up";

/* カスタム例外 */
class SignUpRepositoryError extends RepositoryError {
  constructor(message) {
    super(message);
    this.name = this.constructor.name;
    this.errorCd = SignUpRepositoryError.getErrorCd();
  }

  static getErrorCd() {
    return "04000";
  }
}

class IlligalAccessError extends SignUpRepositoryError {
  constructor(message) {
    super(message);
    this.name = this.constructor.name;
    this.errorCd = IlligalAccessError.getErrorCd();
  }

  static getErrorCd() {
    return "04001";
  }
}

class AuthCodeExpisedError extends SignUpRepositoryError {
  constructor(message) {
    super(message);
    this.name = this.constructor.name;
    this.errorCd = AuthCodeExpisedError.getErrorCd();
  }

  static getErrorCd() {
    return "04002";
  }
}

class AttemptsExceededError extends SignUpRepositoryError {
  constructor(message) {
    super(message);
    this.name = this.constructor.name;
    this.errorCd = AttemptsExceededError.getErrorCd();
  }

  static getErrorCd() {
    return "04003";
  }
}

class AdminUserAlreadyExistsError extends SignUpRepositoryError {
  constructor(message) {
    super(message);
    this.name = this.constructor.name;
    this.errorCd = AdminUserAlreadyExistsError.getErrorCd();
  }

  static getErrorCd() {
    return "02002";
  }
}

function makeRequestJson(organization, password) {
  let requestJosn = {};

  requestJosn = {
    name: organization.name,
    owner_user_email: organization.ownerUserEmail,
    owner_user_name: organization.ownerUserName,
    owner_user_password: password,
  };

  if (organization.billingAddress) {
    requestJosn.billing_address = {};
    requestJosn.billing_address.company_name = organization.billingAddress.companyName;
    requestJosn.billing_address.person_in_charge_name
      = organization.billingAddress.personInChargeName;
    requestJosn.billing_address.postal_code = organization.billingAddress.postalCode;
    requestJosn.billing_address.state = organization.billingAddress.state;
    requestJosn.billing_address.town = organization.billingAddress.town;
    requestJosn.billing_address.street = organization.billingAddress.street;
    requestJosn.billing_address.building = organization.billingAddress.building;
    requestJosn.billing_address.phone_number = organization.billingAddress.phoneNumber;
  }

  if (organization.paymentInfo) {
    requestJosn.payment_info = {};
    requestJosn.payment_info.payment_method = organization.paymentInfo.paymentMethod;
  }

  return requestJosn;
}

const SignUpRepository = {
  async startEmailVerification(email) {
    const response = await Repository.get(`${RESOURCE}/start-email-verification`, {
      params: {
        email,
      },
    });

    if (response.data.result_cd !== RESULT_CD.SUCCESS) {
      throw new SignUpRepositoryError();
    }

    const result = {
      accessKey: response.data.access_key,
    };
    return result;
  },
  async emailVerification(email, accessKey, authCode) {
    const requestParams = {
      email,
      access_key: accessKey,
      auth_code: authCode,
    };
    const response = await Repository.post(`${RESOURCE}/email-verification`, requestParams);
    const verificationResult = response.data.result_cd === RESULT_CD.SUCCESS;

    // 失敗であれば、内容に応じた例外を送出
    if (!verificationResult) {
      if (response.data.errors[0].error_cd === IlligalAccessError.getErrorCd()) {
        throw new IlligalAccessError();
      } else if (response.data.errors[0].error_cd === AuthCodeExpisedError.getErrorCd()) {
        throw new AuthCodeExpisedError();
      } else if (response.data.errors[0].error_cd === AttemptsExceededError.getErrorCd()) {
        throw new AttemptsExceededError();
      } else if (response.data.errors[0].error_cd === AdminUserAlreadyExistsError.getErrorCd()) {
        throw new AdminUserAlreadyExistsError();
      } else {
        throw new SignUpRepositoryError();
      }
    }

    //　成功時はauthentication_idが返却
    return response.data.authentication_id;
  },

  async endEmailVerification(email, authenticationId) {
    const response = await Repository.post(`${RESOURCE}/end-email-verification`, {
      email,
      authentication_id: authenticationId,
    });

    // 処理に失敗したら予期せぬエラーを出す
    if (response.data.result_cd !== RESULT_CD.SUCCESS) {
      throw new RepositoryError();
    }
  },

  async signUp(organization, password) {
    const requestParams = makeRequestJson(organization, password);
    await Repository.post(`${RESOURCE}`, requestParams);
  },
};

export {
  SignUpRepository,
  SignUpRepositoryError,
  IlligalAccessError,
  AttemptsExceededError,
  AuthCodeExpisedError,
  AdminUserAlreadyExistsError,
};
